import { ICategoryData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import { IMainPhoto, IMemberProfile, IMemberProfileDetail, IMemberTypeTitle } from 'redhotpie-shared-lib/interfaces/IUser';
import { GIF_LOADING } from '../api/GiphyAPIs';
import { APPROVAL_STATUS, COMMENT_MESSAGE_CONTENT_TYPE, PLACE_ID_DEFAULT } from '../constants/constants';
import { utils } from '../functions';
import eventSearch from './eventSearch';
import forumTopicDetails from './forumTopicDetails';
import Photo from './photo';
import timezone from './timezone';
import { IEventComment } from 'redhotpie-shared-lib/interfaces/IEvent';
import { IPopularLocation } from 'redhotpie-shared-lib/interfaces/ILocation';
import { ICommonStateCountry, ICommonStateObject } from '../interfaces/IForum';
import { GroupChatDetail } from 'views/ConversationGroupChatView/ConversationGroupChatBody';

export interface IDetailResponse {
  AgeRange?: { AgeFrom: number | null; AgeTo: number | null };
  Description?: string;
  Theme?: string;
  DressCode?: string;
  Rules?: string;
  Cost?: string;
  TicketUrl?: string;
  Phone?: string;
  Email?: string;
  Website?: string;
  GuestTypes?: any[];
  MemberTypeList?: any[];
  EventID?: number | null;
  Title?: string;
  DateHeld?: string;
  Categories?: ICategoryData[];
  OrganiserType?: string;
  EventBannerUrl?: string;
  EventFeaturedBannerUrl?: string;
  EventGlobalBannerUrl?: string;
  Location?: any;
  TimeZone?: any;
  DateHeldUtcIso?: string;
  VideoUrl?: string;
  VideoType?: string;
  VideoCode?: string;
  IsGroupChatAvailable?: boolean;
  IsViewerOwner?: boolean;
  IsTicketUrlPrivate?: boolean;
  IsSponsored?: boolean;
  IsFeatured?: boolean;
  VideoThumbURL?: string;
  ApprovalStatus?: string;
}

export interface IOrganiserResponse {
  __type?: string;
  DisplayEmail?: string;
  Website?: string;
  Description?: string;
  ClubID?: number;
  ClubName?: string;
  UserName?: string;
  Location?: any;
  Categories?: any[];
  Rating?: number;
  MainPhoto?: any;
  MemberID?: number;
  IsViewable?: boolean;
}

export interface IUserInterest {
  eventInterestId: string;
  eventId: number;
  eventTitle: string;
  profile?: IOrganizerUser;
  user?: IOrganizerUser;
  dateExpressed: string;
  hasTicketAccess: boolean;
  hasGroupChatAccess: boolean;
  googleMapPlaceId: string;
}

export interface IOrganizerUser {
  userId: number | null;
  userName: string;
  memberType: number | null;
  memberTypeTitle?: IMemberTypeTitle;
  age1: number | null;
  age2: number | null;
  ageTitle: string;
  location: string;
  matchingInterests: null;
  mainPhoto?: IMainPhoto;
  isOnline: false;
  memberLevel: null;
  isDiamond: false;
  countryId: null;
  isViewable: boolean;

  // add follow types:
  // __type: Organiser.__type ? Organiser.__type : '',
  // displayEmail: Organiser.DisplayEmail ? Organiser.DisplayEmail : '',
  // website: Organiser.Website ? Organiser.Website : '',
  // description: Organiser.Description ? Organiser.Description : '',
  // clubId: Organiser.ClubID ? Organiser.ClubID : 0,
  // clubName:
  //   OrganiserType === 'Club' ? (Organiser.ClubName ? Organiser.ClubName : null) : Organiser.UserName ? Organiser.UserName : null,
  // location: Organiser.Location ? eventSearch.mappingObjectLocation(Organiser.Location) : null,
  // categories:
  //   Organiser.Categories && Organiser.Categories.length > 0
  //     ? Organiser.Categories.map(item => eventSearch.mappingObjectCategory(item))
  //     : [],
  // rating: Organiser.Rating ? Organiser.Rating : null,
  // mainPhoto: Organiser.MainPhoto ? eventSearch.mappingObjectMainPhoto(Organiser.MainPhoto) : null,
  // userId: Organiser.MemberID,
  // isViewable: utils.hasOwnProperty(Organiser, 'IsViewable') ? Organiser.IsViewable : true,
}

export interface EventOrgCategory {
  value: any;
  text: string;
  isMatch: boolean;
}

export interface IOrganizerOther {
  __type: string;
  displayEmail: string;
  website: string;
  description: string;
  clubId: number;
  clubName: string;
  location?: ICommonStateObject;
  categories: EventOrgCategory[];
  rating: number;
  mainPhoto?: IMainPhoto;
  userId: number;
  isViewable: boolean;
  isFeatured?: boolean;
  isSponsored?: boolean;
}
interface IEventDetailData {
  Detail: IDetailResponse;
  Organiser: IOrganiserResponse;
  HasExpressInterest?: boolean;
  OrganiserType?: string;
  SEOUrl?: string;
  IsUserMatching?: boolean;
}

export interface IEventPropertyObject {
  value: any;
  text: string;
  textAbbr: string;
  isMatch: boolean;
}

export interface IEventDetail {
  ageMin: number | null;
  ageMax: number | null;
  description: string;
  theme: string;
  dressCode: string;
  rules: string;
  cost: string;
  ticketUrl: string;
  phone: string;
  email: string;
  website: string;
  guestTypes: IEventPropertyObject[];
  eventId: number;
  title: string;
  dateHeld: string | null;
  categories: IEventPropertyObject[];
  organiserType: string;
  eventBannerUrl: string;
  eventFeaturedBannerUrl: string;
  eventGlobalBannerUrl: string;
  location: any;
  timezone: any;
  dateHeldUtcIso: string | null;
  dateHeldUtcIsoEx?: string | null;
  videoUrl: string;
  videoType: string;
  videoThumbUrl: string;
  videoCode?: string;
  approvalStatus?: string;
}

export default class eventDetail {
  detail: IEventDetail;
  organiser: IOrganizerOther;
  hasExpressInterest: boolean;
  organiserType: string;
  isGroupChatAvailable: boolean;
  totalComment: number;
  isViewerOwner: boolean;
  isTicketUrlPrivate: boolean;
  seoURL: string;
  isUserMatching: boolean;
  isSponsored: boolean;
  isFeatured: boolean;
  groupChatDetail?: GroupChatDetail;
  timeString?: string;
  dateString?: string;

  constructor() {
    this.detail = {
      ageMin: null,
      ageMax: null,
      description: '',
      theme: '',
      dressCode: '',
      rules: '',
      cost: '',
      ticketUrl: '',
      phone: '',
      email: '',
      website: '',
      guestTypes: [],
      eventId: 0,
      title: '',
      dateHeld: '',
      categories: [],
      organiserType: '',
      eventBannerUrl: '',
      eventFeaturedBannerUrl: '',
      eventGlobalBannerUrl: '',
      location: {},
      timezone: null,
      dateHeldUtcIso: null,
      dateHeldUtcIsoEx: null,
      videoUrl: '',
      videoType: '',
      videoThumbUrl: '',
    };
    this.isSponsored = false;
    this.isFeatured = false;
    this.organiser = {
      __type: '',
      displayEmail: '',
      website: '',
      description: '',
      clubId: 0,
      clubName: '',
      location: undefined,
      categories: [],
      rating: 0,
      mainPhoto: undefined,
      userId: 0,
      isViewable: true,
    };
    this.hasExpressInterest = false;
    this.organiserType = 'Member';
    this.isGroupChatAvailable = false;
    this.totalComment = 0;
    this.isViewerOwner = false;
    this.isTicketUrlPrivate = false;
    this.seoURL = '';
    this.isUserMatching = false;
  }

  static mappingPropertyObject(object: any) {
    const newObject: any = {};
    newObject.value = object ? object.Value : '';
    newObject.text = object ? object.Text : '';
    newObject.textAbbr = object ? object.TextAbbr : '';
    newObject.isMatch = object ? object.IsMatch : false;
    return newObject;
  }

  static mappingCategoryToDTO(category: any) {
    return {
      IsMatch: category.isMatch || false,
      Value: category.value,
      Text: category.text || '',
      TextAbbr: category.textAbbr || '',
    };
  }

  static mappingMemberTypeTitle(object: any) {
    const newObject: IMemberTypeTitle = {
      abbr: '',
      plural: '',
      singular: '',
    };
    newObject.abbr = object ? object.Abbr : '';
    newObject.singular = object ? object.Singular : '';
    newObject.plural = object ? object.Plural : '';
    return newObject;
  }

  static mappingEventCategory(_obj: any) {
    const obj: any = {};
    obj.itemID = _obj ? _obj.ItemID : 0;
    obj.itemName = _obj ? _obj.ItemName : '';
    obj.listID = _obj ? _obj.ListID : 0;
    obj.isSelected = false;
    return obj;
  }

  static mappingEventPopularCount(_obj: any, placesParentID?: any) {
    const obj: any = {};
    obj.count = _obj ? _obj.Count : 0;
    obj.googleMapPlaceID = _obj ? _obj.GoogleMapPlaceID : '';
    obj.text = _obj ? _obj.Text : '';
    obj.value = _obj ? _obj.Value : 0;
    obj.textAbbr = _obj ? _obj.TextAbbr : '';
    obj.placesParentID = placesParentID || null;
    return obj;
  }

  static mappingPhoto(_obj: any) {
    const obj: any = {
      photoId: null,
      height: 0,
      width: 0,
      isUserImage: false,
      isPublic: false,
      classification: null,
      thumbUrl: '',
      fullUrl: '',
      showSafeMode: false,
    };
    obj.photoId = _obj.PhotoID;
    obj.height = _obj.Height ? _obj.Height : 0;
    obj.width = _obj.Width ? _obj.Width : 0;
    obj.isUserImage = _obj.IsUserImage ? _obj.IsUserImage : false;
    obj.isPublic = _obj.IsPublic ? _obj.IsPublic : false;
    obj.classification = _obj.Classification;
    obj.thumbUrl = _obj.ThumbUrl ? _obj.ThumbUrl : '';
    obj.fullUrl = _obj.FullUrl ? _obj.FullUrl : '';
    obj.showSafeMode = _obj.ShowSafeMode ? _obj.ShowSafeMode : false;
    return obj;
  }

  static mappingEventUserDetail(user: any) {
    let obj: any = new eventDetail();
    obj = {
      ...obj.detail,
      googleMapPlaceID: '',
      locationLabel: '',
      approvalStatus: '',
    };
    obj.eventId = user.EventID ? user.EventID : null;
    obj.title = user.EventTitle ? user.EventTitle : '';
    obj.googleMapPlaceID = user.GoogleMapPlaceID ? user.GoogleMapPlaceID : null;
    obj.locationLabel = user.LocationLabel ? user.LocationLabel : null;
    obj.guestTypes = user.GuestTypes ? user.GuestTypes : null;
    obj.ageMin = user.AgeRange ? user.AgeRange.AgeFrom : null;
    obj.ageMax = user.AgeRange ? user.AgeRange.AgeTo : null;
    obj.description = user.Description ? user.Description : null;
    obj.theme = user.Theme ? user.Theme : '';
    obj.dressCode = user.DressCode ? user.DressCode : '';
    obj.rules = user.Rules ? user.Rules : '';
    obj.cost = user.Cost ? user.Cost : '';
    obj.ticketUrl = user.TicketUrl ? user.TicketUrl : '';
    obj.phone = user.Phone ? user.Phone : '';
    obj.email = user.Email ? user.Email : '';
    obj.website = user.Website ? user.Website : '';
    obj.dateHeld = user.DateHeld ? user.DateHeld : '';
    obj.approvalStatus = user.ApprovalStatus ? user.ApprovalStatus : '';
    obj.timezone = user.TimeZone ? timezone.mappingObject(user.TimeZone) : null;
    obj.isTicketUrlPrivate = user.IsTicketPrivate || false;
    obj.videoUrl = user.VideoUrl ? user.VideoUrl : '';
    obj.videoType = user.VideoType || null;
    obj.videoThumbUrl = user.VideoThumbUrl || null;
    obj.videoCode = user.VideoCode || null;
    obj.mailOutBanner = user.MailOutBanner !== null ? user.MailOutBanner : null;
    obj.dateHeldUtcIso =
      (user.DateHeldUtcIso &&
        utils.formatDateTimeWithTimezone(
          user.DateHeldUtcIso,
          obj.timezone && utils.hasOwnProperty(obj.timezone, 'ianaName') ? obj.timezone.ianaName : ''
        )) ||
      null;
    obj.dateHeldUtcIsoEx = user.DateHeldUtcIso ? user.DateHeldUtcIso : null;
    obj.banner =
      (user.Banner &&
        utils.hasOwnProperty(user.Banner, 'FileName') &&
        utils.hasOwnProperty(user.Banner, 'BannerUrl') && {
          fileName: user.Banner.FileName,
          bannerUrl: user.Banner.BannerUrl,
        }) ||
      null;
    obj.isSponsored = user.IsSponsored || false;
    obj.isFeatured = user.IsFeatured || false;
    obj.categories = user.Categories?.map((item: any) => eventDetail.mappingPropertyObject(item)) || [];
    return obj;
  }

  static mappingObjectUserInterest(user: any) {
    const obj: IUserInterest = {
      eventInterestId: '',
      eventId: 0,
      profile: undefined,
      user: undefined,
      dateExpressed: '',
      hasTicketAccess: false,
      hasGroupChatAccess: false,
      googleMapPlaceId: '',
      eventTitle: '',
    };
    obj.eventInterestId = user.EventInterestID ? user.EventInterestID : null;
    obj.eventId = user.EventID ? user.EventID : '';
    obj.profile = user.Profile ? eventDetail.mappingObjectOrganizer(user.Profile) : undefined;
    obj.user = user.Profile ? eventDetail.mappingObjectOrganizer(user.Profile) : undefined;
    obj.googleMapPlaceId = user.GoogleMapPlaceID ? user.GoogleMapPlaceID : null;
    obj.dateExpressed = user.DateExpressed ? user.DateExpressed : null;
    obj.hasTicketAccess = user.HasTicketAccess || false;
    obj.hasGroupChatAccess = user.HasGroupChatAccess || false;
    obj.eventTitle = user.EventTitle ? user.EventTitle : '';

    return obj;
  }

  static mappingObjectOrganizer(user: any): IOrganizerUser {
    const obj: IOrganizerUser = {
      userId: null,
      userName: '',
      memberType: null,
      memberTypeTitle: undefined,
      age1: null,
      age2: null,
      ageTitle: '',
      location: '',
      matchingInterests: null,
      mainPhoto: {},
      isOnline: false,
      memberLevel: null,
      isDiamond: false,
      countryId: null,
      isViewable: true,
    };
    obj.userId = user.MemberID ? user.MemberID : null;
    obj.userName = user.UserName ? user.UserName : null;
    obj.memberType = user.MemberType ? user.MemberType : null;
    obj.memberTypeTitle = user.MemberTypeTitle ? eventDetail.mappingMemberTypeTitle(user.MemberTypeTitle) : undefined;
    obj.age1 = user.Age1 ? user.Age1 : null;
    obj.age2 = user.Age2 ? user.Age2 : null;
    obj.ageTitle = user.AgeTitle ? user.AgeTitle : null;
    obj.location = user.Location ? user.Location : null;
    obj.matchingInterests = user.MatchingInterests ? user.MatchingInterests : 0;
    obj.mainPhoto = user.MainPhoto ? Photo.mappingObject(user.MainPhoto) : {};
    obj.isOnline = user.IsOnline ? user.IsOnline : false;
    obj.memberLevel = user.MemberLevel ? user.MemberLevel : 0;
    obj.isDiamond = user.IsDiamond ? user.IsDiamond : false;
    obj.countryId = user.CountryID ? user.CountryID : false;
    obj.isViewable = utils.hasOwnProperty(user, 'IsViewable') ? user.IsViewable : true;

    return obj;
  }

  static mappingObjectsProfile(_data: any[]) {
    const data: any[] = [];
    _data.forEach(item => {
      const _item = eventDetail.mappingObjectOrganizer(item);
      data.push(_item);
    });
    return data;
  }

  static mappingObjectEventInterest(user: any) {
    const { Profile, InterestItem } = user;
    let obj: any = {
      dateListItem: '',
    };
    if (Profile) {
      obj = {
        ...obj,
        ...eventDetail.mappingObjectOrganizer(Profile),
      };
    } else {
      obj = {
        ...obj,
        ...eventDetail.mappingObjectOrganizer(user),
      };
    }
    obj.dateListItem = user.DateListItem ? user.DateListItem : '';
    obj.hasTicketAccess = (InterestItem && InterestItem.HasTicketAccess) || false;
    obj.hasGroupChatAccess = (InterestItem && InterestItem.HasGroupChatAccess) || false;
    obj.eventId = (InterestItem && InterestItem.EventID) || -1;
    obj.interestId = (InterestItem && InterestItem.InterestID) || -1;
    return obj;
  }

  static mappingObjectComment(_obj: any): IEventComment {
    const obj: any = {
      commentId: null,
      commentParentId: null,
      subject: '',
      message: '',
      dateCreated: '',
      replyCount: 0,
      isLiked: false,
      likeCount: 0,
      profile: {},
      isHasMoreReply: false,
      pageNumber: -1,
      messageContentType: COMMENT_MESSAGE_CONTENT_TYPE.TEXT,
      imageContent: {},
    };
    obj.commentId = _obj.CommentID;
    obj.commentParentId = !!_obj.CommentParentID ? _obj.CommentParentID : null;
    obj.subject = _obj.Subject ? _obj.Subject : '';
    obj.message = utils.convertEnterStringToTagHTML(_obj.Message);
    obj.dateCreated = _obj.DateCreated ? _obj.DateCreated : '';
    obj.replyCount = _obj.ReplyCount ? _obj.ReplyCount : 0;
    obj.isLiked = _obj.IsLiked ? _obj.IsLiked : false;
    obj.likeCount = _obj.LikeCount ? _obj.LikeCount : 0;
    obj.profile = _obj.Profile ? eventDetail.mappingObjectOrganizer(_obj.Profile) : {};
    obj.messageContentType = _obj.MessageContentType;
    obj.imageContent = _obj && _obj.ImageContent ? forumTopicDetails.mappingObjectImage(_obj.ImageContent) : {};
    if (_obj.MessageContentType === COMMENT_MESSAGE_CONTENT_TYPE.GIFFY) {
      obj.imageContent.fullUrl = _obj && _obj.GiphyImage ? GIF_LOADING.replace('{id}', _obj.GiphyImage.GiphyImageID) : '';
      obj.imageContent.width = _obj && _obj.GiphyImage ? _obj.GiphyImage.Width : 0;
      obj.imageContent.height = _obj && _obj.GiphyImage ? _obj.GiphyImage.Height : 0;
    }
    if (_obj.MessageContentType === COMMENT_MESSAGE_CONTENT_TYPE.IMAGE) {
      obj.imageContent = _obj && _obj.ImageContent ? forumTopicDetails.mappingObjectImage(_obj.ImageContent) : {};
    }
    return obj;
  }

  static mappingObject(data: IEventDetailData) {
    const { Detail, Organiser, HasExpressInterest, OrganiserType, SEOUrl, IsUserMatching } = data;
    const _eventDetail = new eventDetail();
    _eventDetail.detail = {
      ageMin: Detail.AgeRange ? Detail.AgeRange.AgeFrom : null,
      ageMax: Detail.AgeRange ? Detail.AgeRange.AgeTo : null,
      approvalStatus: Detail.ApprovalStatus ? Detail.ApprovalStatus : '',
      description: Detail.Description ? utils.convertEnterStringToTagHTML(Detail.Description) : '',
      theme: Detail.Theme ? Detail.Theme : '',
      dressCode: Detail.DressCode ? Detail.DressCode : '',
      rules: Detail.Rules ? utils.convertEnterStringToTagHTML(Detail.Rules) : '',
      cost: Detail.Cost ? Detail.Cost : '',
      ticketUrl: Detail.TicketUrl ? Detail.TicketUrl : '',
      phone: Detail.Phone ? Detail.Phone : '',
      email: Detail.Email ? Detail.Email : '',
      website: Detail.Website ? Detail.Website : '',
      guestTypes: Detail.GuestTypes ? Detail.GuestTypes.map(item => eventDetail.mappingPropertyObject(item)) : [],
      eventId: Detail.EventID ? Detail.EventID : 0,
      title: Detail.Title ? Detail.Title : '',
      dateHeld: Detail.DateHeld ? Detail.DateHeld : null,
      categories: Detail.Categories ? Detail.Categories.map(item => eventDetail.mappingPropertyObject(item)) : [],
      organiserType: Detail.OrganiserType ? Detail.OrganiserType : '',
      eventBannerUrl: Detail.EventBannerUrl ? Detail.EventBannerUrl : '',
      eventFeaturedBannerUrl: Detail.EventFeaturedBannerUrl ? Detail.EventFeaturedBannerUrl : '',
      eventGlobalBannerUrl: Detail.EventGlobalBannerUrl ? Detail.EventGlobalBannerUrl : '',
      location: Detail.Location ? eventSearch.mappingObjectLocation(Detail.Location) : {},
      timezone: Detail.TimeZone ? timezone.mappingObject(Detail.TimeZone) : null,
      dateHeldUtcIso: Detail.DateHeldUtcIso ? Detail.DateHeldUtcIso : null,
      videoUrl: Detail.VideoUrl ? Detail.VideoUrl : '',
      videoType: Detail.VideoType || '',
      videoCode: Detail.VideoCode || '',
      videoThumbUrl: Detail.VideoThumbURL || '',
    };
    _eventDetail.organiser = {
      __type: Organiser.__type ? Organiser.__type : '',
      displayEmail: Organiser.DisplayEmail ? Organiser.DisplayEmail : '',
      website: Organiser.Website ? Organiser.Website : '',
      description: Organiser.Description ? Organiser.Description : '',
      clubId: Organiser.ClubID ? Organiser.ClubID : 0,
      clubName: OrganiserType === 'Club' ? (Organiser.ClubName ? Organiser.ClubName : '') : Organiser.UserName ? Organiser.UserName : '',
      location: Organiser.Location ? eventSearch.mappingObjectLocation(Organiser.Location) : undefined,
      categories:
        Organiser.Categories && Organiser.Categories.length > 0
          ? Organiser.Categories.map(item => eventSearch.mappingObjectCategory(item))
          : [],
      rating: Organiser.Rating ? Organiser.Rating : 0,
      mainPhoto: Organiser.MainPhoto ? eventSearch.mappingObjectMainPhoto(Organiser.MainPhoto) : undefined,
      userId: Organiser.MemberID || 0,
      isViewable: !!Organiser.IsViewable,
    };
    _eventDetail.hasExpressInterest = HasExpressInterest || false;
    _eventDetail.isUserMatching = IsUserMatching || false;
    _eventDetail.organiserType = OrganiserType || '';
    _eventDetail.isGroupChatAvailable = Detail.IsGroupChatAvailable || false;
    _eventDetail.isViewerOwner = Detail.IsViewerOwner || false;
    _eventDetail.isTicketUrlPrivate = Detail.IsTicketUrlPrivate || false;
    _eventDetail.seoURL = SEOUrl || '';
    _eventDetail.isUserMatching = IsUserMatching || false;
    return _eventDetail;
  }

  static mappingObjectsCustomInterestMember(_users: any[]) {
    const users: IUserInterest[] = [];
    _users.forEach(_user => {
      const user = eventDetail.mappingObjectUserInterest(_user.eventDetail || _user);
      users.push(user);
    });
    return users;
  }

  static mappingObjectsEventInterest(_users: any[]) {
    const users: any[] = [];
    _users.forEach(_user => {
      const user = eventDetail.mappingObjectEventInterest(_user.eventDetail || _user);
      users.push(user);
    });
    return users;
  }

  static mappingObjectsEventComment(data: any): {
    items: IEventComment[];
    totalComment: number;
  } {
    const datas: IEventComment[] = [];
    if (data) {
      const comments = utils.hasOwnProperty(data, 'Comments') ? data.Comments : data;
      if (Array.isArray(comments)) {
        comments.forEach(_obj => {
          const obj = eventDetail.mappingObjectComment(_obj);
          datas.push(obj);
        });
      }
    }

    return {
      items: datas,
      totalComment: (data && data.TotalItems) || 0,
    };
  }

  static mappingEventCategories(data: any[]): any[] {
    const datas: any[] = [];
    data.forEach(_obj => {
      const obj = eventDetail.mappingEventCategory(_obj);
      datas.push(obj);
    });
    return datas;
  }

  static mappingEventPopularCounts(data: any[], placesParentID: any): IPopularLocation[] {
    const datas: IPopularLocation[] = [];
    data.forEach(_obj => {
      const obj = eventDetail.mappingEventPopularCount(_obj, placesParentID);
      datas.push(obj);
    });
    return datas;
  }

  static getEventPopularDefault(_obj: any): IPopularLocation {
    return eventDetail.mappingEventPopularCount({
      ..._obj,
      GoogleMapPlaceID: PLACE_ID_DEFAULT,
    });
  }
}
